import { IBrands, IBrandsGeneric } from "global-types/global.types";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Navigation } from "swiper";
import Brands from "../Brands/Brands";
import "swiper/swiper-bundle.css";
import { t } from "@/helper/helper";

interface Props {
  data: IBrands<IBrandsGeneric[]>;
  locale: string;
  mt: number;
  mb: number;
}

export default function BrandSlider({ data, locale, mt, mb }: Props) {
  SwiperCore.use([Autoplay, Navigation]);

  return (
    <div
      className={`brand-carousel`}
      style={{
        marginTop: mt,
        marginBottom: mb,
      }}
    >
      <div className="brands-banner">
        <div className="title">{t("brands", locale)}</div>
      </div>
      <div className="container">
        <Swiper
          id="daily"
          tag="section"
          wrapperTag="div"
          loop={true}
          spaceBetween={24}
          slidesPerView={4}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          breakpoints={{
            // when window width is >= 640px
            320: {
              slidesPerView: 1.2,
              spaceBetween: 8,
            },
            480: {
              slidesPerView: 1.2,
              spaceBetween: 16,
            },
            768: {
              slidesPerView: 2.6,
              spaceBetween: 16,
            },
            1199: {
              slidesPerView: 4,
              spaceBetween: 16,
            },
          }}
        >
          {data.data.map((item, index) => (
            <SwiperSlide key={index.toString() + item.name}>
              <Brands data={item} locale={locale} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
